// Shared frame for the standalone pages (privacy notice, disputes, password reset)
const SimplePage = ({ title, children }) => (
  <div className="min-h-screen bg-gradient-to-br from-amber-50 to-amber-100 py-10 px-4">
    <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-xl border border-amber-200 p-6 sm:p-10">
      <a href="/" className="text-sm font-bold text-amber-700 hover:underline">conocetuinquilino</a>
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mt-3 mb-6">{title}</h1>
      {children}
    </div>
  </div>
);

const inputClass = "w-full px-4 py-3 border-2 border-amber-200 rounded-lg focus:ring-2 focus:ring-amber-300 focus:border-amber-400 bg-white";
const buttonClass = "w-full bg-amber-500 hover:bg-amber-600 text-white font-bold py-3 px-6 rounded-lg disabled:opacity-50";

export { SimplePage, inputClass, buttonClass };
